import { Box, TextField, Typography } from '@mui/material';
import CharCounter from './CharCounter';
import { MAX_CHARS } from './versoBlocks';

interface NotificationTextFieldProps {
  label: string;
  hint: string;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  multiline?: boolean;
}

function NotificationTextField({ label, hint, value, onChange, placeholder, multiline = false }: NotificationTextFieldProps) {
  return (
    <Box>
      <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5, fontSize: '0.82rem' }}>
        {label}{' '}
        <Typography component="span" variant="caption" color="text.secondary">
          ({MAX_CHARS} caractères maximum) :
        </Typography>
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1, fontSize: '0.75rem', fontStyle: 'italic' }}>
        {hint}
      </Typography>
      <TextField
        fullWidth
        multiline={multiline}
        rows={multiline ? 4 : undefined}
        size="small"
        value={value}
        onChange={e => onChange(e.target.value.slice(0, MAX_CHARS))}
        placeholder={placeholder}
        slotProps={{ htmlInput: { maxLength: MAX_CHARS } }}
        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
      />
      <CharCounter count={value.length} />
    </Box>
  );
}

export default NotificationTextField;
